import { useRoles } from 'src/user/Auth'
import { useDmSettings } from '../dennemeyer/DennemeyerProvider'

export type RenewalImplementation = 'none' | 'dennemeyer' | 'dummy' | 'patent-renewal'

export function useSettings() {
  // Concrete service provider has precedence over dummy
  const { hasDummyAnnuities, hasDennemeyerAnnuities, hasPrAnnuities } = useRoles()

  const { settings: dmSettings  }=  useDmSettings()

  let implementation: RenewalImplementation = 'none'
  let startDate = undefined
  let support_email = 'support@patent-cockpit.com'

  if (hasDennemeyerAnnuities) {
    implementation = 'dennemeyer'
    startDate = dmSettings?.startDate
    support_email = 'taxes@dennemeyer.com' 
  } else if (hasDummyAnnuities) {
    implementation = 'dummy'
  } else if (hasPrAnnuities) {
    implementation = 'patent-renewal'
  }

  return { support_email, implementation, startDate }
}
